// Keep this module import-free. It is pulled in at module scope by the store,
// which services/commons.js imports inside the `@/utilities` → `@/router` →
// `@/services` → `@running_app_src/store` cycle: any dependency here would be
// half-initialized by the time the store reads these constants.
// Config-driven behaviour lives in booking-engine/logic/package-type-tabs.js,
// which only components import.

export const PACKAGE_TYPES = {
  FLIGHT_AND_STAY: "flight-and-stay",
  ONLY_STAY: "only-stay",
};

// The config addresses the two flows by provider name, not by package type:
// the `sololand.*` service keys, `sliderHome.<provider>` and
// `guiSettings.customizations.defaultBookingEngineTab` all speak this dialect.
export const PACKAGE_TYPE_PROVIDER = {
  [PACKAGE_TYPES.FLIGHT_AND_STAY]: "alpitour",
  [PACKAGE_TYPES.ONLY_STAY]: "sololand",
};

export const endpoints_keys = {
  keyds: "keyds",
  keydsMap: "keydsMap",
  airports: "airports",
  availabilities: "availabilities",
  search: "search",
  price: "price",
  details: "details",
  quote: "quote",
  book: "book",
  confirm: "confirm",
};
